module.exports = __webpack_public_path__ + "img/vmcXmasPartyHawaiian.a4cad6c0.jpg";